import styled, { css } from 'styled-components';

import colors from '@shared/design-tokens/colors';
import { centerIcons, unselectable } from '@web-packages/library/layouts';

import variants from './variants';

const defaultStateCSS = css`
  ${({ variant }) => {
    const defaultStyles = {
      [variants.darkBlue]: {
        stroke: colors.core.darkBlue,
        color: colors.core.darkBlue,
      },
      [variants.white]: {
        stroke: colors.white,
        color: colors.white,
      },
      [variants.coral]: {
        stroke: colors.core.coral,
        color: colors.core.coral,
      },
    };
    return defaultStyles[variant] || defaultStyles[variants.darkBlue];
  }}
`;

/** styled-components */
// eslint-disable-next-line import/prefer-default-export
export const Button = styled.button`
  all:unset;
  ${centerIcons}
  .icon-button-text, .icon-button-icon {
    ${defaultStateCSS}
  }

  .icon-button-icon {
    order: 0;
    ${({ textFirst }) => textFirst && 'order: 1;'}
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .icon-button-text {
    ${unselectable}
    ${{
    order: '1',
    'margin-left': '10px',
    'margin-right': '0px',
  }}
    ${({ textFirst }) => textFirst && {
    order: '0',
    'margin-left': '0px',
    'margin-right': '10px',
  }}
  }
`;
